<template>
  <div id="app" v-bind:style="[ activeFotoDisplayP ? {'overflow':'hidden'} : {'':''}]">
    <NavBar></NavBar>
    <MoNavBar></MoNavBar>
    <transition name="fade" mode="out-in">
      <router-view @FotoDisplay="FotoDisplayP()"></router-view>
    </transition>
    <FooterBar></FooterBar>
  </div>
</template>

<script>
import NavBar from './components/shared/navbar.vue'
import MoNavBar from './components/shared/monavbar.vue'
import FooterBar from './components/shared/footer.vue'
import Portfolio from './components/portfolio/portfolio.vue'

export default {
  name: 'app',
  components: {
    MoNavBar,
    NavBar,
    FooterBar,
    Portfolio
  },
  data() {
    return{
      activeFotoDisplayP: false
    }
  },
  methods: {
    FotoDisplayP() {
      this.activeFotoDisplayP = !this.activeFotoDisplayP;
    }
  }

}
</script>

<style>
@import url('https://use.fontawesome.com/releases/v5.7.2/css/all.css');
@import url('https://fonts.googleapis.com/css?family=Raleway:200,400,700,900');

*{
  padding: 0;
  margin: 0;
}

html, body, #app{
  width: 100%;
  height: 100%;
}
#app {
  font-family: 'Segoe UI', sans-serif;
}

.fade-enter-active,
.fade-leave-active {
  transition: 0.3s ease;
}

.fade-enter,
.fade-leave-active {
  transform: scale(0.98);
  //transform: scale(0.95) skewY(2deg);
  //transform: skewY(2deg);
  opacity: 0.7;
}
</style>
